/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RecommendationDetails { 
    ffppLaunch?: number;
    ffppLaunchDelta?: number;
    base?: number;
    baseDelta?: number;
    live?: number;
    liveDelta?: number;
    recommended?: number;
    recommendedDelta?: number;
    confirmed?: number;
    confirmedDelta?: number;
    reason?: string;
}

